import { z } from "zod";
import { sourceLinkSchema } from "./place";

export const reportChangeSchema = z.object({
  id: z.string(),
  fieldPath: z.string(),
  oldValue: z.unknown().optional(),
  proposedValue: z.unknown().optional(),
  decision: z.string(),
  decisionNote: z.string().nullable().optional(),
});

export const reportSchema = z.object({
  id: z.string(),
  reportType: z.string(),
  title: z.string(),
  summary: z.string().nullable().optional(),
  status: z.string(),
  reviewNote: z.string().nullable().optional(),
  createdAt: z.string(),
  submittedAt: z.string().nullable().optional(),
  targetPlaceId: z.string().nullable().optional(),
  targetEventId: z.string().nullable().optional(),
  changes: z.array(reportChangeSchema).default([]),
  sourceLinks: z.array(sourceLinkSchema).default([]),
});
export type ReportDto = z.infer<typeof reportSchema>;
